import camelCase from 'lodash/camelCase';
import { createConsts, createActions } from '../../utils/redux';
import { REPORT_RESOURCES, UI_POPUP_TYPES } from '../../constants/props';

export const consts = createConsts(
  'ui',
  'popup',
  'SHOW',
  'HIDE',
  'TOGGLE_CONTENT',
);
export const actions = createActions(consts);

const getReportAction = type => id => ({
  type: consts.SHOW,
  payload: {
    contentType: UI_POPUP_TYPES.REPORT,
    contentOptions: {
      resource: type,
      id,
    },
  },
});

const createCustomActions = (types, func) => {
  return Object.keys(types).reduce((acc, action) => {
    const key = camelCase(action);
    acc[key] = func(key);
    return acc;
  }, {});
};

export const showLoaderInPopup = () => ({
  type: consts.SHOW,
  payload: { contentType: UI_POPUP_TYPES.LOADER },
});

export const hideLoaderInPopup = () => ({
  type: consts.HIDE,
  payload: { contentType: UI_POPUP_TYPES.LOADER },
});

export const showMobileAppPopup = () => ({
  type: consts.SHOW,
  payload: { contentType: UI_POPUP_TYPES.MOBILE_APP },
});

export const hideMobileAppPopup = () => ({
  type: consts.HIDE,
  payload: { contentType: UI_POPUP_TYPES.MOBILE_APP },
});

export const showMfaNoticePopup = () => ({
  type: consts.SHOW,
  payload: { contentType: UI_POPUP_TYPES.MFA_NOTICE },
});

export const hideMfaNoticePopup = () => ({
  type: consts.HIDE,
  payload: { contentType: UI_POPUP_TYPES.MFA_NOTICE },
});

export const reportActions = createCustomActions(
  REPORT_RESOURCES,
  getReportAction,
);

export const unassignedAction = () => ({
  type: consts.SHOW,
  payload: {
    contentType: UI_POPUP_TYPES.MESSAGE,
    contentOptions: {
      message: { id: 'circle.confirmUnassigned' },
    },
  },
});

export const socialChatAlertAction = () => ({
  type: consts.SHOW,
  payload: {
    contentType: UI_POPUP_TYPES.MESSAGE,
    contentOptions: {
      icon: 'information',
      message: { id: 'intro.messages.socialChatArchived' },
    },
  },
});

export const showDependentCreateModal = ({
  onClose = () => {},
  messageId = 'dependent.form.createComplete',
} = {}) => ({
  type: consts.SHOW,
  payload: {
    contentType: UI_POPUP_TYPES.MESSAGE,
    contentOptions: {
      message: { id: messageId },
      icon: 'icon-clock',
      popupAction: onClose,
      onSubmit: onClose,
    },
  },
});

const initialState = {
  visible: false,
  contentType: '',
  contentOptions: {},
  secondaryContentVisible: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case consts.SHOW:
      return {
        ...state,
        visible: true,
        contentType: payload.contentType,
        contentOptions: payload.contentOptions,
      };
    case consts.HIDE:
      return {
        ...state,
        visible: false,
      };
    case consts.TOGGLE_CONTENT:
      return {
        ...state,
        secondaryContentVisible: !state.secondaryContentVisible,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/popup.js